import classnames from 'classnames';
import React /* , {useEffect, useRef} */ from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ClientSwitcher from 'Components/Explorer/common/ClientSwitcher';
import OnClickOutside from 'Components/common/OnClickOutside/OnClickOutside';
import * as PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
    background: {
        background: '#000000CC',
        backdropFilter: 'blur(4px)',
        pointerEvents: 'auto !important',
    },
}));

const ClientSwitcherModal = props => {
    const modalClasses = useStyles();

    // TODO: Refactor the code below as it is is very similar to WelcomeModal

    if (!props.settings) {
        return null;
    }

    const selectedClientId = props.settings.clientId;
    const parentClientId = props.settings.parentClientId ?? props.settings.clientId;
    const parentClient = props.settings.clientList.find(client => client.id === parentClientId);
    const clientList = [
        {id: parentClientId, name: parentClient.name, navMapId: parentClient.navMapId},
        ...props.settings.clientList
            .sort((c1, c2) => c1.name.localeCompare(c2.name))
            .filter(client => client.id !== parentClientId),
    ];
    const isClientSwitcherVisible = props.settings.enableClientSwitching && clientList.length > 1;

    if (!isClientSwitcherVisible) {
        return null;
    }

    return (
        <div className={classnames('overlay', 'infoPanelOverlay', modalClasses.background)}>
            <OnClickOutside onClickOutside={props.onClose}>
                <div>
                    <ClientSwitcher
                        isAlwaysExpanded
                        clientList={clientList}
                        selectedClientId={selectedClientId}
                        onClick={client => {
                            if (client.id !== selectedClientId) {
                                window.location.href = `?navmapId=${client.navMapId}&autoload=y`;
                            } else {
                                props.onClose();
                            }
                        }}
                    />
                </div>
            </OnClickOutside>
        </div>
    );
};

ClientSwitcherModal.propTypes = {
    settings: PropTypes.object,
    onClose: PropTypes.func.isRequired,
};

export default ClientSwitcherModal;
